var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5A11.48 11.48 0 1023.46 12 11.48 11.48 0 0012 .5",
    fill: "#fff",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12 12 0 0012 0m0 1A11 11 0 111 12 11 11 0 0112 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.47 18a.51.51 0 01-.36-.15L11 12.73V7.48a.51.51 0 01.51-.5.5.5 0 01.5.5v4.83l4.84 4.81a.5.5 0 010 .71.51.51 0 01-.36.15"
  })));
}
SvgExpiry.displayName = 'Expiry';
export default SvgExpiry;